import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { NugetType } from '@models';
import { urlStateHandler, } from '@pages/generics/grid';
import { NugetGridComponent } from './grids';
var ɵ0 = urlStateHandler;
var LibrariesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LibrariesPageComponent, _super);
    function LibrariesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = NugetType.Libraries;
        return _this;
    }
    LibrariesPageComponent.prototype.ngOnInit = function () {
        this.createPermission = this._appState.user.loggedInAsHost ?
            '' :
            'Libraries.Create';
    };
    return LibrariesPageComponent;
}(NugetGridComponent));
export { LibrariesPageComponent };
export { ɵ0 };
